export const FLOATING_ELEMENT_SIDE_OFFSET = 6;
export const FLOATING_ELEMENT_COLLISION_PADDING = 10;

export const EMOJI_FONT_FAMILY =
  "'Apple Color Emoji', 'Noto Color Emoji', 'Twemoji Mozilla', 'Android Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', EmojiSymbols, sans-serif";

export const MENTION_CHARACTER = "@";
